"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const new_item_1 = __importDefault(require("./new-item"));
class NewDataUpload extends new_item_1.default {
    constructor(newDataUpload) {
        super();
        this.file = newDataUpload.file;
        this.groupName = newDataUpload.groupName;
        this.noHeaders = newDataUpload.noHeaders;
        this.columnData = newDataUpload.columnData;
        this.csvFileNames = newDataUpload.csvFileNames;
        this.uploaded = newDataUpload.uploaded;
        this.dataItemsLayout = newDataUpload.dataItemsLayout;
        this.dataItemsColumn = newDataUpload.dataItemsColumn;
        this.dataItems = newDataUpload.dataItems;
        this.newDevices = newDataUpload.newDevices;
        this.newSites = newDataUpload.newSites;
        this.dataTypes = newDataUpload.dataTypes;
        this.previewSampleData = newDataUpload.previewSampleData;
        this.processedErrors = newDataUpload.processedErrors;
        this.processingStatusDetails = newDataUpload.processingStatusDetails;
        this.uploadingStatusDetails = newDataUpload.uploadingStatusDetails;
        this.status = newDataUpload.status;
    }
}
exports.default = NewDataUpload;
//# sourceMappingURL=new-dataUpload.js.map